import React from 'react';
import { BankAccountInfoPresentational } from './bank-account-info-presentational';
import { useState } from 'react';
import { Form, message } from 'antd';
import { useEffect } from 'react';
import Axios from 'axios';

import { appConstant, apiUrl } from '@constants';
import { getAuthToken, getAuthKey } from '@helpers';

import Selectors from '@sharedComponent/app-action-reducer/selectors';
import { connect } from 'react-redux';

const BankAccountInfoFunctional = ({ userDetails }) => {
	var valid = require('us-bank-account-validator');
	const [formRef] = Form.useForm();

	const [isEditActive, setIsEditActive] = useState(false);

	const [state, setState] = useState({
		isMaskRouting: true,
		accountsList: [],
		loading: true,
		isMaskAccount: true,
		currentDeleteAccountId: null,
		activeModal: false,
		activeDeleteModal: false,
		addbankLoading: false,
		editBankLoading: false,
		deleteBankLoading: false,

		isAccountMask: true,
		isConfirmAccountMask: true,
		isRoutingMask: true,
		isConfirmRoutingMask: true,

		isAccountValid: true,
		isConfirmAccountValid: true,
		isConfirmRoutingValid: true,
		isRoutingValid: true,

		inactiveAccountList: [],
	});

	const [bankForm, setBankForm] = useState({
		bankName: '',
		accountId: null,
		isActive: false,
		accountNickName: '',
		accountType: '',
		routingNumber: '',
		accountNumber: '',
		confirmRoutingNumber: '',
		confirmAccountNumber: '',
	});

	const handleBankChange = (label, value) => {
		setBankForm({
			...bankForm,
			[label]: value,
		});
	};

	const [addBankForm, setAddBankForm] = useState({
		authKey: '',
		accountType: '',
		bankName: '',
		accountNickName: '',
		routingNumber: '',
		accountNumber: '',
		confirmRoutingNumber: '',
		confirmAccountNumber: '',
	});

	const handleAddBankChange = (label, value) => {
		setAddBankForm({
			...addBankForm,
			[label]: value,
		});
	};

	const handleChange = (label, value) => {
		setState({
			...state,
			[label]: value,
		});
	};

	const accountValidate = (label, value) => {
		handleChange(label, valid.accountNumber(value).isValid);
	};
	const routingValidate = (label, value) => {
		handleChange(label, valid.routingNumber(value).isValid);
	};

	const onFinish = async (values) => {
		const authKey = await getAuthKey();
		const authToken = await getAuthToken();
		accountValidate('isAccountValid', addBankForm.accountNumber);
		accountValidate('isConfirmAccountValid', addBankForm.confirmAccountNumber);
		routingValidate('isConfirmRoutingValid', addBankForm.confirmRoutingNumber);
		routingValidate('isRoutingValid', addBankForm.routingNumber);
		let request = {
			authKey: authKey || '',
			accountType: addBankForm.accountType || '',
			bankName: addBankForm.bankName || '',
			accountNickName: addBankForm.accountNickName || '',
			routingNumber: addBankForm.routingNumber || '',
			accountNumber: addBankForm.accountNumber || '',
		};
		setState({
			...state,
			addbankLoading: true,
		});
		if (state.isAccountValid && state.isConfirmAccountValid && state.isRoutingValid && state.isConfirmRoutingValid) {
			Axios.get(`${appConstant.domain + apiUrl.HEALTH}`).then(() => {
				Axios.post(`${appConstant.domain + apiUrl.SAVE_BANK}`, request, { headers: { Authorization: authToken } })
					.then((saveBankResponse) => {
						// useEffect();
						message.success('New Bank Added Successfully');
						new Promise((resolve) => {
							resolve();
						}).then(() => {
							window.location.reload(false);
							setState({
								...state,
								addbankLoading: false,
							});
							// getActiveBank();
						});
					})
					.catch((e) => {
						setState({
							...state,
							addbankLoading: false,
						});
						if (e.response) {
							message.error(e.response && e.response.data && e.response.data.messages && e.response.data.messages[0]);
						}
					});
			});
		}
	};

	const updateActiveBank = async () => {
		const authKey = await getAuthKey();
		const authToken = await getAuthToken();
		accountValidate('isAccountValid', bankForm.accountNumber);
		accountValidate('isConfirmAccountValid', bankForm.confirmAccountNumber);
		routingValidate('isConfirmRoutingValid', bankForm.confirmRoutingNumber);
		routingValidate('isRoutingValid', bankForm.routingNumber);
		let request = {
			authKey: authKey || '',
			accountType: bankForm.accountType || '',
			bankName: bankForm.bankName || '',
			accountNickName: bankForm.accountNickName || '',
			routingNumber: bankForm.routingNumber || '',
			accountNumber: bankForm.accountNumber || '',
			isActive: true,
			accountId: bankForm.accountId || '',
		};
		setState({
			...state,
			editBankLoading: true,
		});
		if (state.isAccountValid && state.isConfirmAccountValid && state.isRoutingValid && state.isConfirmRoutingValid) {
			Axios.get(`${appConstant.domain + apiUrl.HEALTH}`).then(() => {
				Axios.put(`${appConstant.domain + apiUrl.UPDATE_BANK}`, request, { headers: { Authorization: authToken } })
					.then((saveBankResponse) => {
						// useEffect();
						message.success(' Bank Updated Successfully');
						window.location.reload(false);
						setState({
							...state,
							editBankLoading: false,
						});
					})
					.catch((e) => {
						setState({
							...state,
							editBankLoading: false,
						});
						if (e.response) {
							message.error(e.response && e.response.data && e.response.data.messages && e.response.data.messages[0]);
						}
					});
			});
		}
	};

	const deleteBank = async (accountId) => {
		const authKey = await getAuthKey();
		const authToken = await getAuthToken();
		let request = {
			authKey: authKey,
			accountId: accountId,
		};
		Axios.delete(`${appConstant.domain + apiUrl.DELETE_BANK}`, { headers: { Authorization: authToken }, data: request })
			.then((deleteBankResponse) => {
				if (deleteBankResponse.data.success) {
					message.success('Bank Delete successfully');
					// handleChange('activeDeleteModal', false);
					// getActiveBank();
					window.location.reload();
				}
				setState({
					...state,
					deleteBankLoading: false,
				});
			})
			.catch((e) => {
				setState({
					...state,
					deleteBankLoading: false,
				});
				if (e.response) {
					message.error(e.response && e.response.data && e.response.data.messages && e.response.data.messages[0]);
				}
			});
	};

	const activateBank = async (accountId) => {
		const authKey = await getAuthKey();
		const authToken = await getAuthToken();
		let request = {
			authKey: authKey,
			accountId: accountId,
		};
		Axios.put(`${appConstant.domain + apiUrl.ACTIVATE_BANK}`, request, { headers: { Authorization: authToken } })
			.then((activateBankResponse) => {
				if (activateBankResponse.data.success) {
					message.success('Bank Activated successfully');
					window.location.reload();
					// getActiveBank();
				}
			})
			.catch((e) => {
				if (e.response) {
					message.error(e.response && e.response.data && e.response.data.messages && e.response.data.messages[0]);
				}
			});
	};

	const getActiveBank = async () => {
		const authKey = await getAuthKey();
		const authToken = await getAuthToken();
		Axios.get(`${appConstant.domain + apiUrl.HEALTH}`).then(() => {
			Axios.get(`${appConstant.domain + apiUrl.GET_ACTIVE_BANK + authKey}`, {
				headers: {
					Authorization: authToken,
				},
			})
				.then((getActiveBankResponse) => {
					if (getActiveBankResponse.data.success && getActiveBankResponse.data.messages.length > 0) {
						let arr = [];
						getActiveBankResponse.data.messages.map((res) => {
							if (res.isActive) {
								setBankForm({
									...bankForm,
									bankName: res.bankName || '',
									accountId: res.accountId || null,
									accountNickName: res.accountNickName || '',
									accountType: res.accountType || '',
									isActive: res.isActive || false,
									routingNumber: res.routingNumber || '',
									confirmRoutingNumber: res.confirmRoutingNumber || '',
									accountNumber: res.accountNumber || '',
									confirmAccountNumber: res.confirmAccountNumber || '',
								});
							} else {
								arr.push(res);
							}
							return res;
						});
						setState({
							...state,
							loading: false,
							accountsList: getActiveBankResponse.data.messages || [],
							inactiveAccountList: arr,
						});
					} else {
						setState({
							accountsList: [],
							...state,
							loading: false,
						});
					}
				})
				.catch(() => {
					setState({
						...state,
						loading: false,
						accountsList: [],
					});
				});
		});
	};
	const deleteActiveBank = () => {
		if (bankForm.accountId) {
			setState({
				...state,
				deleteBankLoading: true,
			});
			deleteBank(bankForm.accountId);
		}
	};

	const resetActiveAccount = () => {
		setIsEditActive(false);
		if (state.accountsList.length > 0) {
			state.accountsList.map((res) => {
				if (res.isActive) {
					setBankForm({
						...bankForm,
						bankName: res.bankName || '',
						accountId: res.accountId || null,
						accountNickName: res.accountNickName || '',
						accountType: res.accountType || '',
						isActive: res.isActive || false,
						routingNumber: res.routingNumber || '',
						confirmRoutingNumber: res.confirmRoutingNumber || '',
						accountNumber: res.accountNumber || '',
						confirmAccountNumber: res.confirmAccountNumber || '',
					});
				}
				return res;
			});
		}
	};

	useEffect(() => {
		getActiveBank();
	}, []);

	return (
		<BankAccountInfoPresentational
			state={state}
			bankForm={bankForm}
			addBankForm={addBankForm}
			formRef={formRef}
			handleAddBankChange={handleAddBankChange}
			routingValidate={routingValidate}
			accountValidate={accountValidate}
			handleChange={handleChange}
			onFinish={onFinish}
			deleteBank={deleteBank}
			activateBank={activateBank}
			handleBankChange={handleBankChange}
			userDetails={userDetails}
			setIsEditActive={setIsEditActive}
			isEditActive={isEditActive}
			deleteActiveBank={deleteActiveBank}
			updateActiveBank={updateActiveBank}
			resetActiveAccount={resetActiveAccount}
		/>
	);
};

const mapStateToProps = (state) => {
	return {
		userDetails: Selectors.userDetails(state),
	};
};

const Connected = connect(mapStateToProps, null)(BankAccountInfoFunctional);

export default Connected;
